<template>
    <div class="row">
        <div class="col-xs-12">
            <div
                id="app-macros"
                class="box box-primary"
            >
                <div class="box-header with-border">
                    <h3 class="box-title">Macros Table</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            data-toggle="tooltip"
                            data-widget="collapse"
                            title="Collapse"
                            type="button"
                        >
                            <i class="fa fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- /.box-header -->
                <div
                    v-if="!macros"
                    class="box-body"
                >
                    <p>There is no Macros in the system.</p>
                </div>
                <div v-else>
                    <div class="box-header with-border">
                        <div
                            class="pagination-box"
                            @click="preventEnter"
                            @keydown="preventEnter"
                        >
                            <pagination
                                :class="isDisabled()"
                                :data="macros"
                                :limit="$root.paginator.settings.limit"
                                :size="$root.paginator.settings.size"
                                class="pull-right no-margin vue-pagination"
                                showDisabled
                                @pagination-change-page="getData"
                            >
                                <span slot="prev-nav">
                                    <i class="fa fa-angle-double-left"></i>
                                </span>
                                <span slot="next-nav">
                                    <i class="fa fa-angle-double-right"></i>
                                </span>
                            </pagination>
                        </div>
                    </div>

                    <div class="box-body table-responsive no-padding">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Active</th>
                                    <th>Shortcode</th>
                                    <th>Length</th>
                                    <th>Values</th>
                                    <th class="text-right">Created At</th>
                                    <th class="text-right">Updated At</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- item start -->
                                <tr
                                    v-for="macro in macros.data"
                                    :key="macro.i"
                                >
                                    <td>{{ macro.id }}</td>
                                    <td>{{ macro.name }}</td>
                                    <td>
                                        <value-yes-no :value="macro.active === 1"></value-yes-no>
                                    </td>
                                    <td>
                                        <code>{{ macro.code }}</code>
                                    </td>
                                    <td>
                                        <span class="label bg-gray">{{ macro.length }}</span>
                                    </td>
                                    <td class="total-values">
                                        <span
                                            class="label bg-gray"
                                            title="Total"
                                            >{{ macro.values_count }}</span
                                        >
                                        <span
                                            class="label bg-green"
                                            title="Active"
                                            >{{ macro.values_active }}</span
                                        >
                                        <span
                                            class="label bg-red"
                                            title="Inactive"
                                            >{{ macro.values_count - macro.values_active }}</span
                                        >
                                    </td>
                                    <td class="text-right">{{ macro.created_at }}</td>
                                    <td class="text-right">{{ macro.updated_at }}</td>
                                    <td class="text-right">
                                        <button
                                            v-show="macro.active"
                                            class="btn btn-sm btn-danger"
                                            type="button"
                                            title="Deactivate"
                                            @click="activateDeactivate(true, macro.id, modalDeactivateID)"
                                        >
                                            <i class="fa fa-ban"></i>
                                            <span class="sr-only">Deactivate</span>
                                        </button>
                                        <button
                                            v-show="!macro.active"
                                            class="btn btn-sm btn-success"
                                            type="button"
                                            title="Activate"
                                            @click="activateDeactivate(true, macro.id, modalActivateID)"
                                        >
                                            <i class="fa fa-check"></i>
                                            <span class="sr-only">Activate</span>
                                        </button>
                                        <a
                                            v-show="!isUserOrPublisher"
                                            :href="getRouteEdit(macro.id)"
                                            class="btn btn-sm btn-primary"
                                        >
                                            <i class="fa fa-edit"></i>
                                            <span class="sr-only">Edit</span>
                                        </a>
                                        <a
                                            :href="getRouteShow(macro.id)"
                                            class="btn btn-sm btn-info"
                                        >
                                            <i class="fa fa-eye"></i>
                                            <span class="sr-only">Show</span>
                                        </a>
                                    </td>
                                </tr>
                                <!-- item end -->
                            </tbody>
                        </table>
                    </div>
                    <!-- /.box-body -->
                    <div class="box-footer clearfix">
                        <div
                            class="pagination-box"
                            @click="preventEnter"
                            @keydown="preventEnter"
                        >
                            <pagination
                                :class="isDisabled()"
                                :data="macros"
                                :limit="$root.paginator.settings.limit"
                                :size="$root.paginator.settings.size"
                                class="pull-right no-margin vue-pagination"
                                showDisabled
                                @pagination-change-page="getData"
                            >
                                <span slot="prev-nav">
                                    <i class="fa fa-angle-double-left"></i>
                                </span>
                                <span slot="next-nav">
                                    <i class="fa fa-angle-double-right"></i>
                                </span>
                            </pagination>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.box -->
        </div>
    </div>
</template>

<script>
import ValueYesNo from '../subcomponents/ValueYesNo';
export default {
    components: { ValueYesNo },
    data() {
        return {
            macros: {},
            selectedIds: [],
            disablePagination: true,
            isUserOrPublisher: true,
            modalDeactivateID: '#macroDeactivateAllModal',
            modalActivateID: '#macroActivateAllModal',
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        preventEnter: function (event) {
            if (this.disablePagination) {
                return event.preventDefault();
            }
        },
        getData(page = 1) {
            this.disablePagination = true;
            axios.get('/macros/index-data?page=' + page).then((response) => {
                if (String(page) !== String(this.$route.query.page)) {
                    this.$router.push({ query: Object.assign({}, this.$route.query, { page: String(page) }) });
                }

                if (page > response.data.macros.last_page) {
                    return this.getData();
                }

                this.macros = response.data.macros;
                this.isUserOrPublisher = response.data.isUserOrPublisher;
                this.disablePagination = false;
            });
        },
        selectAllItems: function (event) {
            if (!event.target.checked) {
                this.selectedIds = [];

                return;
            }

            let app = this;

            _.forEach(app.macros.data, (item) => {
                if (item['values_active'] > 0) {
                    app.selectedIds.push(item['id']);
                }
            });
        },
        activateDeactivate: function (single, id, modalId) {
            let ids = single ? [id] : this.selectedIds,
                $modal = $(modalId);
            $modal.find('form input[name="macros_ids"]').val(JSON.stringify(ids));
            $modal.find('.modal-body p span').text(ids.join(', '));
            $modal.modal();
        },
        getRouteShow: function (id) {
            return this.$attrs['route-show'].replace(':id:', id);
        },
        getRouteEdit: function (id) {
            return this.$attrs['route-edit'].replace(':id:', id);
        },
        isDisabled: function () {
            return this.disablePagination ? 'disabled-box' : '';
        },
    },
};
</script>
